export const processSteps = [
  {
    title: "Culture",
    text: "Sols calcaires du Luberon, rotation des parcelles, aucun intrant de synthèse.",
  },
  {
    title: "Récolte",
    text: "À pleine floraison, au petit matin, quand la plante concentre ses actifs.",
  },
  {
    title: "Distillation",
    text: "Vapeur d'eau, alambics cuivre, dans les 24 heures suivant la coupe.",
  },
  {
    title: "Contrôle",
    text: "GC-MS sur chaque lot, certificat d'analyse et échantillon témoin conservé.",
  },
  {
    title: "Expédition",
    text: "Conditionnement inox ou alu, livraison Europe en 48 à 72 h.",
  },
];

export const qualityDocuments = [
  { name: "Certificat d'analyse (CoA)", detail: "Par lot, GC-MS" },
  { name: "Fiche de données de sécurité", detail: "FDS conforme REACH" },
  { name: "Déclaration IFRA", detail: "51ᵉ amendement" },
  { name: "Allergènes", detail: "Règlement UE 2023/1545" },
  { name: "Fiche technique & spécifications", detail: "Indices physico-chimiques" },
  { name: "Certificats biologiques", detail: "COSMOS · Ecocert · AB" },
];

export const certifications = [
  "COSMOS Organic",
  "Ecocert",
  "Agriculture Biologique",
  "AOP Lavande de Haute-Provence",
  "Conforme REACH",
  "IFRA 51",
];
